<script>
    import {fade} from 'svelte/transition';
    import {navigateTo} from 'svelte-router-spa';
    import {PRConnect} from "@projectroom/ui-lib";
	import { _ } from 'svelte-i18n';
	import { Card, Button, Dialog } from '../lib/ui';

    let refPhoneNo;
    let refMessageToken;
    let phoneNo;
    let messageToken;
    let messageTokenFlag = false;
    let phoneSubmitFlag = true;
    let errorMessage;
    let successMessage;
    let phoneBorder = false;
    let messageTokenBorder = false;
    let reSubmitTime = 60;
    let showSubmitTime = "1:00";
    let findPopupFlag;
    let emailId;

    // shadcn 인풋 공용 클래스
    const inputCls = "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-opacity-50";
    const errStyle = "border-color:hsl(var(--sb-destructive))";

    const validPhoneNo = () => {
        // 전화번호 유효성체크, 우선 길이정도
        if (refPhoneNo.value.length === 11) {
            errorMessage = undefined;
            return false;
        }
        return true;
    }

    const validMessageToken = () => {
        // 메세지토큰 유효성체크, 우선 길이정도
        if (refMessageToken.value.length === 6) {
            errorMessage = undefined;
            return false;
        }
        return true;
    }
    const clickPhoneNoSubmit = () => {
        if (validPhoneNo()) {
            errorMessage= $_('project.default.20_FindEmail');
            return;
        }
        refPhoneNo.readOnly = true;
        messageTokenFlag = true;
        PRConnect.send("/api/Auth/messageTokenPublish", {phoneNo:refPhoneNo.value, type:"findEmail"}, data => {
            if (data.header.status === "success") {
                if (data.result.status === "error") {
                    navigateTo("/login");
                    return;
                }
                console.log("messageTokenPublish success");
                successMessage = $_('project.default.21');
                makeReSubmit();
            }
        });

    }

    const makeReSubmit = () => {
        messageTokenFlag = true;
        phoneSubmitFlag = false;
        const interval = setInterval(() => {
            try {
                if (reSubmitTime < 1) {
                phoneSubmitFlag=true;
                refPhoneNo.readOnly=false;
                reSubmitTime=60;
                showSubmitTime=`0:${reSubmitTime}`;
                clearInterval(interval);
                }
                --reSubmitTime;
                if (reSubmitTime < 10) {
                    showSubmitTime=`0:0${reSubmitTime}`;
                } else {
                    showSubmitTime=`0:${reSubmitTime}`;
                }
            } catch(error) {
                console.log("makeReSubmit fail : ", error);
                clearInterval(interval);
            }
        }, 1000);
    }

    const clickJoinSubmit = () => {
        if (validPhoneNo()) {
            errorMessage= $_('project.default.22');
            return;
        }
        if (!messageTokenFlag) {
            errorMessage= $_('project.default.23');
            return;
        }
        if (validMessageToken()) {
            errorMessage = $_('project.default.24');
            return;
        }

        PRConnect.send("/api/Auth/findEmailByPhoneNo", {phoneNo:refPhoneNo.value, messageToken:refMessageToken.value}, data => {
            if (data.header.status === "success") {
                if (data.result.status === "error") {
                    console.log("clickJoinSubmit fail");
                    return;
                }
                if (data.result.status === "fail") {
                    errorMessage = data.result.message;
                    if (data.result.type == "messageToken") {
                        messageTokenBorder = true;
                        return;
                    }
                    phoneBorder = true;
                }
                findPopupFlag = true;
                emailId = data.result.message;
            }
        });
    }

    const changePhoneNo = () => {
        phoneBorder = validPhoneNo();
    }

    const changeMessageToken = () => {
        messageTokenBorder = validMessageToken();
    }

</script>

<div class="tw-flex tw-min-h-screen tw-justify-center tw-bg-background tw-px-4 tw-pb-20 tw-pt-24 tw-font-sans tw-text-foreground sm:tw-pt-28" in:fade>
    <div class="tw-w-full tw-max-w-[420px]">
        <Card class="tw-p-8 sm:tw-p-10">
            <h1 class="tw-mb-1 tw-text-center tw-text-2xl tw-font-bold tw-text-foreground">{$_('project.default.25')}</h1>

            {#if errorMessage}
                <div class="tw-mt-4 tw-rounded-md tw-bg-destructive/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-destructive">{errorMessage}</div>
            {/if}
            {#if successMessage}
                <div class="tw-mt-4 tw-rounded-md tw-bg-primary/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-primary">{successMessage}</div>
            {/if}

            <form class="tw-mt-6 tw-space-y-4" on:submit|preventDefault={clickJoinSubmit}>
                <div>
                    <label for="find-phone" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.26')}</label>
                    <div class="tw-flex tw-gap-2">
                        <input id="find-phone" type="tel" inputmode="numeric" bind:this={refPhoneNo} maxlength="11" placeholder={$_('project.default.27')} on:change={changePhoneNo} class="{inputCls} tw-flex-1" style={phoneBorder ? errStyle : ""} />
                        {#if phoneSubmitFlag}
                            <Button type="button" variant="secondary" class="tw-h-11 tw-shrink-0" on:click={clickPhoneNoSubmit}>{$_('project.default.28')}</Button>
                        {:else}
                            <Button type="button" variant="secondary" disabled class="tw-h-11 tw-shrink-0 tw-tabular-nums">{showSubmitTime}</Button>
                        {/if}
                    </div>
                </div>

                {#if messageTokenFlag}
                    <div>
                        <input type="number" bind:this={refMessageToken} maxlength="6" placeholder={$_('project.default.29')} on:change={changeMessageToken} class={inputCls} style={messageTokenBorder ? errStyle : ""} />
                    </div>
                {/if}

                <Button type="submit" size="lg" class="tw-w-full">{$_('project.default.30')}</Button>
            </form>

            <p class="tw-mt-6 tw-text-center tw-text-sm tw-text-muted-foreground">
                {$_('project.default.31')}
                <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-font-semibold tw-text-primary hover:tw-underline" on:click={()=>navigateTo("/login")}>{$_('project.default.32')}</button>
            </p>
        </Card>
    </div>
</div>

<Dialog open={findPopupFlag} title={$_('project.default.33')} on:close={()=> findPopupFlag = false}>
    <div class="tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-px-4 tw-py-5 tw-text-center tw-text-base tw-font-semibold tw-text-foreground">{emailId}</div>
    <div slot="footer" class="tw-flex tw-gap-2">
        <Button variant="outline" on:click={()=> findPopupFlag = false}>{$_('project.default.34')}</Button>
        <Button on:click={()=> navigateTo("/login")}>{$_('project.default.35')}</Button>
    </div>
</Dialog>
